import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Logo } from 'app/dealer/shared/components/TopNavBar/Logo';

import { TitleSt, LogoSt, TitleTextSt, TitleDealerPortal } from './Title.css';

export class Title extends React.PureComponent {
  render() {
    const {
      className,
      title,
      to,
      isDealerPortal,
      isHome,
      isStuck,
      onClick,
    } = this.props;

    return (
      <TitleSt
        onClick={onClick}
        className={className}
        isHome={isHome}
        isStuck={isStuck}
      >
        <LogoSt to={to}>
          <Logo />
        </LogoSt>

        {isDealerPortal && (
          <TitleDealerPortal>
            <FormattedMessage
              id="dealer.topnavbar.logo.text"
              defaultMessage="Händlerportal"
            />
          </TitleDealerPortal>
        )}

        {title && <TitleTextSt>{title}</TitleTextSt>}
      </TitleSt>
    );
  }
}

Title.propTypes = {
  className: PropTypes.string,
  isDealerPortal: PropTypes.bool,
  isHome: PropTypes.bool,
  isStuck: PropTypes.bool,
  onClick: PropTypes.func,
  title: PropTypes.any,
  to: PropTypes.string,
};

Title.defaultProps = {
  className: '',
  title: null,
  to: '/',
  isDealerPortal: false,
  isHome: false,
  isStuck: false,
};
